import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { EVENTS_QUERY } from '../graphql/queries'
import { COMMON_FETCH_EVENTS } from '../redux/action-types'
import { cleanupCommonFetchEvents } from '../redux/actions'
import { apolloService } from '../services'

import useCleanupRedux from './use-cleanup-redux'

const useEventsQuery = (page, pageSize, filters) => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupCommonFetchEvents)

  const {
    isCommonFetchEventsLoading: isLoading,
    fetchEventsError: error,
    eventsData: data = {},
  } = useSelector(store => store.common.events)

  const refetch = useCallback(
    () =>
      apolloService.query(
        EVENTS_QUERY,
        {
          page: Number(page),
          pageSize: Number(pageSize),
          filters: {
            ...filters,
            startAt: new Date(filters.startAt),
            endAt: new Date(filters.endAt),
          },
        },
        dispatch,
        COMMON_FETCH_EVENTS,
      ),
    [dispatch, filters, page, pageSize],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, data }
}

export default useEventsQuery
